export default {
    "fr": {
        "Back": "Retour",
        "Cancel": "Annuler",
        "Edit": "Modifier",
        "Close": "Fermer",
        "Choose": "Choisir",
        "Delete": "Supprimer",
        "Send": "Envoyer",
        "Preview": "Prévisualisation"
    },
    "en": {
        "Back": "Back",
        "Cancel": "Cancel",
        "Edit": "Edit",
        "Close": "Close",
        "Choose": "Choose",
        "Delete": "Delete",
        "Send": "Send",
        "Preview": "Preview"
    }
}
